// frontend/src/api/webhooks.js
/**
 * Webhook API — thin wrappers around the /api/orgs/me/webhooks endpoints (P12-G13).
 *
 * All endpoints require admin or owner role.
 */
import client from "./client";

/**
 * List every webhook registered for the active org.
 * @returns {Promise<Array<WebhookRead>>}
 */
export async function listWebhooks() {
  const { data } = await client.get("/api/orgs/me/webhooks");
  return data;
}

/**
 * Register a new webhook endpoint.
 * @param {{ url: string, secret: string, events: string[] }} payload
 * @returns {Promise<WebhookRead>}
 */
export async function createWebhook(payload) {
  const { data } = await client.post("/api/orgs/me/webhooks", payload);
  return data;
}

/**
 * Permanently delete a webhook.
 * @param {string} webhookId  UUID of the webhook to remove
 * @returns {Promise<void>}
 */
export async function deleteWebhook(webhookId) {
  await client.delete(`/api/orgs/me/webhooks/${webhookId}`);
}
